import { COUNTRIES, Locales, Series, ZONES } from '@types';

const CAMBODIA: Series = {
  id: 'cambodia',
  name: { [Locales.EN]: 'Cambodia', [Locales.FR]: 'Cambodge' },
  location: { zone: ZONES.ASIA, country: COUNTRIES.KH },
  sortType: 'date_asc',
  isZoneHighlight: true,
};

export default CAMBODIA;
